/**
 * Podium widget: unwrap "Leave a Review" <button> from inside <a> (invalid HTML / WCAG 4.1.2).
 * Merge visible rating text into the link accessible name (WCAG 2.5.3 F96).
 */
(function () {
  function fixPodiumNestedControls() {
    document.querySelectorAll('a[href] button[aria-label="Leave a Review"]').forEach(function (btn) {
      var link = btn.closest('a');
      if (!link || !link.contains(btn) || link.dataset.a11yPodiumUnwrap) return;
      link.dataset.a11yPodiumUnwrap = '1';
      if (link.parentNode) {
        link.parentNode.insertBefore(btn, link.nextSibling);
      }
    });

    document.querySelectorAll('a[href]').forEach(function (a) {
      var al = a.getAttribute('aria-label');
      if (!al || !/review/i.test(al)) return;
      var vis = (a.innerText || a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!vis || al.indexOf(vis) !== -1) return;
      a.setAttribute('aria-label', vis + ' ' + al);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixPodiumNestedControls);
  } else {
    fixPodiumNestedControls();
  }

  var obs = new MutationObserver(fixPodiumNestedControls);
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  }
  setTimeout(function () {
    obs.disconnect();
  }, 15000);
  setTimeout(fixPodiumNestedControls, 3000);
})();
